module.exports = __webpack_public_path__ + "static/media/icon_159.78338aea.svg";